__turbopack_context__.v({
  "icon": "MCrdTW_icon",
  "pill": "MCrdTW_pill",
});
